import React from 'react';

import Customers from '../../../components/Customers';
import { LandingCta, LandingSection, LandingSectionHeader } from '../../components';

function CustomersSection() {
  return <LandingSection>
    <LandingSectionHeader eyebrow="Trusted By" title="Over 500+ Customers Worldwide" description="Accurate and Reliable Metal Prices for Gold Trading, Manufacturing, Recycling and Bullion Businesses" />
    <Customers />
    <LandingCta />
  </LandingSection>;
}

export default CustomersSection;
